import * as React from 'react';
import SidePane from 'owa-calendar-sidepane/lib/component/SidePane';
import { observer } from 'mobx-react-lite';
import { TaskPaneCollection } from 'owa-addins-core';

const AddinSidePane = observer(function AddinSidePane(props: {}) {
    return (
        <SidePane showHeader={false} isOpened={true}>
            <TaskPaneCollection renderTaskPaneInPanel={false} />
        </SidePane>
    );
});
export default AddinSidePane;
